var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowershell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48.000000pt",
    height: "48.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82 407 c-14 -17 -85 -324 -77 -337 10 -16 380 -13 393 3 14 17 85 324 77 337 -10 16 -380 13 -393 -3z m378 -11 c0 -13 -69 -297 -75 -305 -6 -10 -365 -17 -365 -7 0 13 69 297 75 305 6 10 365 17 365 7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147 373 c-16 -15 -5 -41 33 -78 22 -21 40 -42 40 -46 0 -4 -32 -29 -70 -55 -54 -37 -70 -53 -68 -69 5 -36 41 -26 122 33 113 82 113 79 36 157 -62 62 -79 73 -93 58z m133 -133 c0 -6 -166 -120 -174 -120 -20 0 3 22 69 68 l76 53 -46 52 c-65 74 -56 82 15 12 33 -33 60 -62 60 -65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224 135 c-11 -27 10 -36 72 -33 51 3 59 6 59 23 0 18 -8 20 -63 23 -50 2 -63 0 -68 -13z m94 -12 c-16 -2 -40 -2 -55 0 -16 2 -3 4 27 4 30 0 43 -2 28 -4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowershell);
export default __webpack_public_path__ + "static/media/powershell.410195636fe9e3286e0c5a5100340a2a.svg";
export { ForwardRef as ReactComponent };